// see https://github.com/cwgrant/ol3/commit/f63a8567417e1e7d3045bd43ca495881a11717c2 for implementation for ArcGISRest post 3.3.0
// but no support for FeatureServer, which we'll probably want
// TODO: make distinction that this is a Rhythm.GIS.Layer factory not an OL3 factory
import Mediator = require("../mediator");
import Utils = require("../utils");
import Portal = require("portal-gis");
import AgsDirectory = require("../utils/ags/ags-directory");
import Base = require("./base-command");

class Command extends Base<any> {

    static about = `
Uses the _directoryService_ method provided by _utils/ags/ags-directory_ to obtain layer definitions
and add them to the layer collection of the configuration.
Requires a "url" option to perform a discovery of all available services.
    `;

    static options = {
        "url": "the ags discovery endpoint"
    }

    execute(args = this.args) {
        var options = this.options;
        Utils.ifOption(options, "url", url => {
            AgsDirectory.directoryService(url).done(layers => {
                layers.forEach(layer => this.mediator.config.Map.Layers.Layers.push(layer));
                this.trigger({ layers: layers });
            });
        });
    }

}

export = Command;
